import { ViteReactSSG } from 'vite-react-ssg'
import { routes } from './App'
import { i18nPromise } from './config/i18n/i18n';

export const createRoot = ViteReactSSG(
  {
    routes,
    basename: import.meta.env.BASE_URL,
  },
  async () => {
    await i18nPromise;
  },
);